import Ajax from 'Utils/ajax';
export const getThoughtOfTheDay = data => Ajax.post("configs/getThoughtOfTheDay", data);